export enum MeasureReferenceType {
    None = 0,
    Gax = 1,
    FDX = 2,
    horsFDX = 3
}
